/**
 * Get saved state of the topic
 * @param {Array<SavedList>} savedLists
 * @returns {boolean} true if the topic is saved, false otherwise
 */
function isSavedToTopics(topics) {
  const topic = topics.find((topic) => topic.d === 0)
  return !!topic
}

function findFirstUnsavedTopic(topics) {
  return topics.find((topic) => topic.d === 1)
}

function findFirstSavedTopic(topics) {
  return topics.find((topic) => topic.d === 0)
}

export default class TopicListSelector {
  static getSelectedTopics(newTopicList, topicList) {
    const reducer = (accumulator, newTopic, index) => {
      const topic = topicList[index]
      if (newTopic.d !== topic.d) {
        accumulator.push(newTopic)
      }
      return accumulator
    }
    return newTopicList.reduce(reducer, [])
  }

  static getSavedStateChangedTopic(newTopicList, topicList) {
    const isSavedBefore = isSavedToTopics(topicList)
    const isSavedNow = isSavedToTopics(newTopicList)
    if (isSavedNow === isSavedBefore) {
      return
    }
    if (isSavedNow) {
      return findFirstSavedTopic(newTopicList)
    }
    return findFirstUnsavedTopic(newTopicList)
  }
}
